'use strict';

var Sugar = require('sugar-core');

require('./build/buildMathAliasesCall');

module.exports = Sugar.Number.exp;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/exp.js
// module id = 670
// module chunks = 0